import { FollowButton } from 'components/ui';
import { throttle } from 'lodash';
import React, { ReactElement, useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { Organization, useOrganizationsApi } from 'services/api';
import { isOrganizationFollowedState, markOrganizationAsUserModified } from 'state/followed-organizations/followed-organizations.state';

export interface FollowOrganizationButtonProps {
  organizationId: Organization['id'];
}

export const FollowOrganizationButton = ({
  organizationId,
}: FollowOrganizationButtonProps): ReactElement => {
  const [isFollowed, setFollowed] = useRecoilState<boolean>(
    isOrganizationFollowedState(organizationId),
  );
  const organizationsApi = useOrganizationsApi();

  const toggleFollowed = useCallback(
    throttle(
      async (isFollowed: boolean) => {
        // Mark this org as user-modified to prevent API data from overwriting
        markOrganizationAsUserModified(organizationId);
        setFollowed(!isFollowed);
        if (isFollowed)
          await organizationsApi.unfollowOrganization(organizationId);
        else await organizationsApi.followOrganization(organizationId);
      },
      80,
      { trailing: false },
    ),
    [],
  );

  const handleClickFollow = () => {
    void toggleFollowed(isFollowed);
  };

  return <FollowButton following={isFollowed} onClick={handleClickFollow} />;
};
